// extracted by mini-css-extract-plugin
export default {"snippet":"Snippet_snippet__uthA5"};